export const IMAGES = {
  logo: "/images/logo.png",
  hero: "/images/hero.jpg",
  karm006: "/images/karm-006.jpg",
  karm008: "/images/karm-008.jpg",
  karm010: "/images/karm-010.jpg",
  appIcon: "/images/app-icon.jpg",
};

export const PHONE_DISPLAY = "8989099599";
export const PHONE_TEL = "tel:+918989099599";
export const WA_NUMBER = "918989099599";
export const WA_LINK = `https://wa.me/${WA_NUMBER}`;
export const EMAIL = "karmindustrieskatni@gmail.com";
export const ADDRESS = "Plot No. 41, Amkuhi Industrial Area, Katni, Madhya Pradesh, India";

export const waWithMessage = (message) =>
  `${WA_LINK}?text=${encodeURIComponent(message)}`;

export const PRODUCTS = [
  {
    code: "KARM 006",
    size: "6 mm",
    price: "₹13,000",
    image: IMAGES.karm006,
    tag: "Premium Grade",
    best: "High-efficiency industrial boilers & pellet stoves",
    specs: [
      ["Diameter", "6 mm"],
      ["Length", "10 – 50 mm"],
      ["Moisture", "≤ 5%"],
      ["Calorific Value (GCV)", "4000 – 4500 kcal/kg"],
      ["Ash Content", "≤ 2 – 4%"],
    ],
  },
  {
    code: "KARM 008",
    size: "8 mm",
    price: "₹12,000",
    image: IMAGES.karm008,
    tag: "Industrial Standard",
    best: "Boilers, kilns & commercial heating systems",
    specs: [
      ["Diameter", "8 mm"],
      ["Net Weight", "30 kg bag"],
      ["Fuel Type", "Carbon Natural"],
      ["Additives", "No Adhesive, No Sulphur"],
      ["Output", "High Calorific Value"],
    ],
  },
  {
    code: "KARM 010",
    size: "10 mm",
    price: "₹9,000",
    image: IMAGES.karm010,
    tag: "Bulk Workhorse",
    best: "Heavy industrial furnaces & bulk fuel supply",
    specs: [
      ["Diameter", "10 mm"],
      ["Length", "10 – 50 mm"],
      ["Moisture", "≤ 5%"],
      ["Calorific Value (GCV)", "3200 – 3700 kcal/kg"],
      ["Ash Content", "≤ 2 – 4%"],
    ],
  },
];

export const RATES = PRODUCTS.map((p) => ({
  code: p.code,
  size: p.size,
  price: p.price,
}));
